/** 希望コースは教科学習コースのみ（運営決定） */
export const hope_course = [
  {
    title: '教科学習コース',
    value: '教科学習コース',
  },
];

/** 利用料（税込）は 5,500 円一律 */
export function getPriceByHopeCourse(hope_course: string): number {
  if (!hope_course) {
    return 0;
  }
  return 5500;
}
